import { styled } from '@mui/material';
import NoAssignments from 'components/Assignments/NoAssignments';
import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, Stack, StudentAssignmentCard, Text, TextInput } from 'shell/components';
import { FEEDBACK_LIMIT } from 'utils/constants';

const Mobile = ({
    batch,
    feedback,
    filters,
    setFilters,
    getFilterCount,
    onClick,
    onClickGetFeedback,
    onClickViewFeedback,
}) => {
    const { auth } = useAuth();
    const { assignments: allAssignments } = useApp();
    const { t } = useTranslation('assignment');

    const assignments = allAssignments.filter(
        ({ ai_student_feedback_enabled, is_draft }) => ai_student_feedback_enabled && !is_draft
    );

    return (
        <Container device={'mobile'}>
            <CustomStack spacing={5}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('assignments', 'Assignments')}
                    </Text>
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={4}>
                    <CustomButton
                        color={'neutral'}
                        startIcon={<Icon kind={'filter'} />}
                        variant={'secondary'}
                        onClick={() => setFilters((current) => ({ ...current, open: true }))}
                    >
                        ({getFilterCount(filters)})
                    </CustomButton>
                    <TextInput
                        aria-label={'search'}
                        endIcon={<Icon kind={'search'} />}
                        placeholder={t('common:controls.search', 'Search')}
                        value={filters.search}
                        onChange={(e) => setFilters((current) => ({ ...current, search: e.target.value }))}
                    />
                </Stack>
                {assignments.length ? (
                    <Stack spacing={4}>
                        {assignments
                            .filter(({ title }) => {
                                return title.toLowerCase().includes(filters.search.toLowerCase());
                            })
                            .sort((a, b) => {
                                if (filters.sort === 'titlea-z') {
                                    const aTitle = a.title.toLowerCase();
                                    const bTitle = b.title.toLowerCase();
                                    if (aTitle < bTitle) return -1;
                                    if (aTitle > bTitle) return 1;
                                }
                                if (filters.sort === 'titlez-a') {
                                    const aTitle = a.title.toLowerCase();
                                    const bTitle = b.title.toLowerCase();
                                    if (aTitle < bTitle) return 1;
                                    if (aTitle > bTitle) return -1;
                                }
                                return 0;
                            })
                            .map((assignment) => (
                                <StudentAssignmentCard
                                    key={assignment.id}
                                    assignment={assignment}
                                    numAttemptsRemaining={
                                        FEEDBACK_LIMIT -
                                        (feedback[assignment.id]?.filter(
                                            ({ owner_account_id }) => owner_account_id === auth.id
                                        )?.length +
                                            batch[assignment.id]?.filter(
                                                ({ owner_account_id }) => owner_account_id === auth.id
                                            )?.length)
                                    }
                                    onClick={onClick}
                                    onClickGetFeedback={onClickGetFeedback}
                                    onClickViewFeedback={onClickViewFeedback}
                                />
                            ))}
                    </Stack>
                ) : (
                    <NoAssignments />
                )}
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

const CustomButton = styled(Button)(() => {
    return {
        flexShrink: 0,
    };
});

export default Mobile;
